module.exports = "pegasus/assets/blocks/column-17-theme3.png";